import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  image_upload_status: {
    front_side: {
      sql_upload_status: 0,
      azure_img_upload_status: 0,
    },
    front_left_side: {
      sql_upload_status: 0,
      azure_img_upload_status: 0,
    },
    left_side: {
      sql_upload_status: 0,
      azure_img_upload_status: 0,
    },
    back_left_side: {
      sql_upload_status: 0,
      azure_img_upload_status: 0,
    },
    back_side: {
      sql_upload_status: 0,
      azure_img_upload_status: 0,
    },
    back_right_side: {
      sql_upload_status: 0,
      azure_img_upload_status: 0,
    },
    right_side: {
      sql_upload_status: 0,
      azure_img_upload_status: 0,
    },
    front_right_side: {
      sql_upload_status: 0,
      azure_img_upload_status: 0,
    },
    outer_windshield: {
      sql_upload_status: 0,
      azure_img_upload_status: 0,
    },
    inner_windshield: {
      sql_upload_status: 0,
      azure_img_upload_status: 0,
    },
    registrationNo: {
      sql_upload_status: 0,
      azure_img_upload_status: 0,
    },
    chassis: {
      sql_upload_status: 0,
      azure_img_upload_status: 0,
    },
    RC: {
      sql_upload_status: 0,
      azure_img_upload_status: 0,
    },
    odometer: {
      sql_upload_status: 0,
      azure_img_upload_status: 0,
    },
    front_left_tyre: {
      sql_upload_status: 0,
      azure_img_upload_status: 0,
    },
    back_left_tyre: {
      sql_upload_status: 0,
      azure_img_upload_status: 0,
    },
    back_right_tyre: {
      sql_upload_status: 0,
      azure_img_upload_status: 0,
    },
    front_right_tyre: {
      sql_upload_status: 0,
      azure_img_upload_status: 0,
    },
    selfie: {
      sql_upload_status: 0,
      azure_img_upload_status: 0,
    },
  },
};

const image_upload_slice = createSlice ({
  name: 'image_upload_status',
  initialState,
  reducers: {
    set_image_upload_status: (state, action) => {
      const { image_name, status, type } = action.payload;
      console.log(image_name,status,type,"91")
      console.log(state.image_upload_status[image_name][type],"90")
      if (state.image_upload_status[image_name]) {
        state.image_upload_status[image_name][type] = status;
        console.log(state.image_upload_status[image_name][type],"94")
      } else {
        console.warn(`Image type ${image_name} does not exist in the state.`);
      }
    },
  },
});

export const {set_image_upload_status} = image_upload_slice.actions;

export default image_upload_slice.reducer;
